// extracted by mini-css-extract-plugin
export default {"CarouselScrollLeftButton":"CarouselScrollLeftButton_CarouselScrollLeftButton__Am25J","arrowImage":"CarouselScrollLeftButton_arrowImage__Ov7bE"};